import Vuex, { createLogger } from "vuex";
import Vue from "vue";
import * as actions from "./actions";
import * as mutations from "./mutations";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
dayjs.extend(isoWeek);

Vue.use(Vuex);

const state = {
  startDay: null,
  endDay: null,
  country: null,
  countries: [],
  team: null,
  teamName: null,
  // The team's URL slug, when the row it was selected from carried one. Only used
  // to write the human-readable path (/temasek-polytechnic) — see
  // src/utils/urlFilters.js. null means the URL falls back to id + name params.
  teamSlug: null,
  // Superteam: a parent entity grouping several teams (e.g. a school/company).
  // Mirrors team (id + display name + slug) — the backend accepts `superteam`
  // wherever it accepts `team`, and the id may be opaque rather than numeric.
  superteam: null,
  superteamName: null,
  superteamSlug: null,
  // Individual (user) filter: mirrors team/teamName. Set by clicking an
  // individual leaderboard row; scopes the dashboard to one user's strides.
  // Mutually exclusive with team (selecting one clears the other).
  userId: null,
  userName: null,
  // Active map selection: a clicked cluster or individual cleanup whose stats
  // the side panel shows instead of the global/filtered figures. null = none.
  selection: null,
  // Global snackbar: any component dispatches `showSnackbar` to raise it; the
  // single <v-snackbar> in App.vue renders it. Avoids per-component copies.
  snackbar: { show: false, message: "", color: "success", timeout: 3000 },
  totalUsers: 0,
  totalCountries: 0,
  stridesUsers: 0,
  stridesCountries: 0,
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  plugins: process.env.NODE_ENV !== "production" ? [createLogger()] : [],
});
